(function (window, document, $) {

    $(document).ready(function () {
        // Anchor scroll ===============================================================================================

        $('body').on('click', '[data-scroll-to]', function (e) {

            if ($(this).hasClass('click_pijler')) {
                showHidePijler(this);
            }

            var target = this.href.split('#')[1];

            if (!target) {
                return true;
            } else {
                e.preventDefault();
            }

            var $target = $('#' + target),
                duration = Math.pow(Math.abs(window.scrollY - $target.offset().top), 2 / 3) * 8;

            if ($target.length > 0) {
                $('body, html').animate({ scrollTop: $target.position().top }, duration, 'swing');
            }
        });

        //scroll to element ID fix on pageload
        function slideToHash() {
            if (window.location.hash) {
                $("html, body").animate({ scrollTop: $(window.location.hash).offset().top - 10 }, 500);
            }
        }
        slideToHash();


        // Page intro menu - anchor scroll =============================================================================

        $('body').on('click', '.page-intro__navigation a[href^="#"]', function (e) {
            e.preventDefault();

            var target = this.href.split('#')[1],
                $target = $('#' + target),
                duration = Math.pow(Math.abs(window.scrollY - $target.offset().top), 2 / 3) * 8;

            if ($target.length > 0) {
                $('body, html').animate({ scrollTop: $target.position().top }, duration, 'swing');
            }
        });


        // smooth scrolling
        // Select all links with hashes
        $('a[href*="#"]:not(".js-dropdown-toggle"):not(".navbar-scrollto-link")')
            // Remove links that don't actually link to anything
            .not('[href="#"]')
            .not('[href="#0"]')
            .on('click', function (event) {
                // On-page links
                if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                    
                    // Figure out element to scroll to
                    var target = $(this.hash);
                    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');

                    // Does a scroll target exist?
                    if (target.length) {
                        // Only prevent default if animation is actually gonna happen
                        event.preventDefault();

                        $('html, body').animate({
                            scrollTop: target.offset().top - 75
                        }, 1000, function () {
                            // Callback after animation
                            // Must change focus!
                            var $target = $(target);
                            $target.focus();
                            if ($target.is(":focus")) { // Checking if the target was focused
                                return false;
                            } else {
                                $target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
                                $target.focus(); // Set focus again
                            }
                        });
                    }
                }
            });
    });

}(window, document, jQuery));
